<template>
  <main
    class="ren-decoration-preview-wrap ren-decoration-canvas"
    :class="[`is-${device}`, `is-${mode}`]"
    :data-device="device"
    :data-preview-mode="mode"
    :style="canvasStyle"
  >
    <slot
      :components="components"
      :selected-id="selectedId"
      :readonly="readonly"
      :select="select"
      :move="move"
      :copy="copy"
      :delete-component="deleteComponent"
      :lock="lock"
    />
  </main>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { RenDecorationComponent } from '../../types'

const props = withDefaults(defineProps<{
  device?: 'phone' | 'tablet'
  mode?: 'sample' | 'live'
  components?: RenDecorationComponent[]
  selectedId?: string
  readonly?: boolean
}>(), {
  device: 'phone',
  mode: 'live',
  components: () => [],
  selectedId: '',
  readonly: false
})

const emit = defineEmits<{
  select: [id: string]
  move: [id: string, offset: -1 | 1]
  copy: [id: string]
  delete: [id: string]
  lock: [id: string, locked: boolean]
  'update:device': [device: 'phone' | 'tablet']
  'update:mode': [mode: 'sample' | 'live']
}>()

const canvasStyle = computed(() => ({
  '--ren-decoration-canvas-width': props.device === 'tablet' ? '768px' : '390px'
}))

const select = (id: string) => emit('select', id)
const move = (id: string, offset: -1 | 1) => emit('move', id, offset)
const copy = (id: string) => emit('copy', id)
const deleteComponent = (id: string) => emit('delete', id)
const lock = (id: string, locked: boolean) => emit('lock', id, locked)
</script>

<style scoped>
.ren-decoration-canvas {
  --ren-decoration-canvas-width: 390px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-width: 0;
  height: 100%;
  overflow: hidden;
  padding: 12px 16px 40px;
  box-sizing: border-box;
  gap: 0;
}

.ren-decoration-canvas.is-tablet {
  --ren-decoration-canvas-width: 768px;
}
</style>
